export default __webpack_public_path__ + "static/media/drop down.6f0e5030.svg";